import React from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Navigate } from "react-router-dom";
import FameWallPte from "../components/Frontend/FameWallPte";
import Testimonial from "../components/Frontend/Testimonial";
import WhyLove from "../components/Frontend/WhyLove";
import Packages from "../components/Frontend/Packages";
import SimpleReactValidator from "simple-react-validator";
import { store } from "store/index";
import { setAlert } from "action/index.js";
import API from "api.js";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import TestimonialVid from "../components/Frontend/VideoPTETestimonial";
import OurStudent from "../components/Frontend/Sliders/ourStudent";
import Slider from "react-slick";
import PhoneInputField from "components/Inputs/PhoneInputField";
import OnlineStudentSlider from "../components/Frontend/Sliders/OnlineStudentSlider";


class Pte extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      name: "",
      email: "",
      phone: "",
      course: "PTE Online",
      query: "",
      flag: false,
      loginLock: false,
      readMoreFlag: false,
    };
    this.validator = new SimpleReactValidator();
  }

  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };

  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactPixel.init("2474090032742391");
    ReactPixel.init("197333187452630");
    ReactPixel.pageView();
  }
  submitForm = (e) => {
    e.preventDefault();
    this.hitApi();
  };

  changeReadMore = () => {
    this.setState({ readMoreFlag: !this.state.readMoreFlag });
  };

  hitApi = async () => {
    if (this.state.loginLock) {
      return;
    }
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return;
    }
    this.setState({ loginLock: true });

    var bodyFormData = new FormData();
    bodyFormData.set("email", this.state.email);
    bodyFormData.set("name", this.state.name);
    bodyFormData.set("phone", this.state.phone);
    bodyFormData.set(
      "message",
      "<b>course:</b> " +
        this.state.course +
        "<br/><b>Query:</b> " +
        this.state.query
    );
    bodyFormData.set(
      "data",
      "email: " +
        this.state.email +
        ",name: " +
        this.state.name +
        ",phone: " +
        this.state.phone +
        ",course: " +
        this.state.course +
        ",query: " +
        this.state.query
    );
    bodyFormData.set("page", "PTE Online Sydney");
    let res = null;
    try {
      res = await API({
        method: "POST",
        url: "sendOnlinePte",
        data: bodyFormData,
      });
    } catch (error) {}
    console.log(res);
    if (res?.status === 200) {
      store.dispatch(
        setAlert({ flag: true, type: 1, message: res.data.message })
      );
      this.setState({
        name: "",
        email: "",
        phone: "",
        course: "PTE On-Campus",
        query: "",
        loginLock: false,
        flag: true,
      });
    } else {
      this.setState({ loginLock: false });
    }
  };

  changeInput = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };
  render() {
    if (this.state.flag) {
      return <Navigate to="/thank-you" replace />;
    }

    const CardsSlider = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 5000,
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>
            PTE Online Coaching Classes Australia | Language Academy
          </title>
          <meta
            name="twitter:title"
            content="PTE Online Coaching | Best PTE Training Institute - Language Academy"
          />
          <meta
            property="og:title"
            content="PTE Online Coaching | Best PTE Training Institute - Language Academy"
          />
          <meta
            name="description"
            content="Enroll in Language Academy's PTE online coaching classes in Australia for expert guidance. Achieve your best score with flexible, personalized learning."
          />

          <meta
            name="twitter:description"
            content="Looking for PTE Online Classes? Language Academy is providing a world-class PTE online coaching to help the students to improve their scores in the Pearson Test Of English. To get demo classes from the leading PTE Coaching center, contact at +61 426230061."
          />
          <meta
            property="og:description"
            content="Looking for PTE Online Classes? Language Academy is providing a world-class PTE online coaching to help the students to improve their scores in the Pearson Test Of English. To get demo classes from the leading PTE Coaching center, contact at +61 426230061."
          />
        </Helmet>
        <Header />

        <div className="banner-section noc-banner">
          <div className="container">
            <div className="row">
              <div className="banner-content">
                <h1 className="primary-heading dark-blue-color">
                  <span className="wpl-badge pte-naati-badge text-white">
                    master pte
                  </span>{" "}
                  <br className="d-block d-md-none" />{" "}
                  <span className="fw-700">FROM ANYWHERE</span>{" "}
                  <br className="d-none d-md-block" />
                  EXPERT PTE ONLINE COACHING THAT
                  <br className="d-none d-md-block" /> DELIVERS REAL RESULTS
                </h1>
                <p className="sub-title">
                  Get the same quality instruction and personalized attention <br className="d-none d-md-block" /> as in-person classes, with the flexibility you need.
                </p>
                <div className="iframe-video-outer position-relative">
                  <div className="banner-img-wrapper">
                    <img
                      className="banner-img"
                      src="/images/web-new-images/banners/poc-banner.png"
                      alt="LA"
                    />
                  </div>
                  <img
                    className="emoji1 position-absolute"
                    src="/images/web-new-images/emojis/emoji-1.png"
                    alt="LA"
                  />
                  <img
                    className="emoji2 position-absolute"
                    src="/images/web-new-images/emojis/emoji-2.png"
                    alt="LA"
                  />
                  <img
                    className="emoji3 position-absolute"
                    src="/images/web-new-images/emojis/emoji-3.png"
                    alt="LA"
                  />
                  <img
                    className="emoji4 position-absolute"
                    src="/images/web-new-images/emojis/emoji-4.png"
                    alt="LA"
                  />
                </div>
                <div className="light-blue-box">
                  Master your English skills with personalized PTE Online Training designed for non-native speakers, test takers, and students. Achieve high PTE scores, improve your English proficiency, and gain the confidence to reach your study, work, or residency goals through our comprehensive PTE Online Course.
                </div>
                <button
                  className="primary-btn mt-2 border-0"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop1"
                >
                  ENROLL IN OUR PROGRAM TODAY
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="noc-ccl-exam naati-ccl-exam poc-future-success">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12">
                <h2 className="primary-heading text-center fw-700">
                  <span className="wpl-badge text-white">WHAT IS PTE?</span>
                  <br className="d-block" />
                  A TEST FOR YOUR <br /> FUTURE SUCCESS
                </h2>
              </div>
              <div className="col-md-6">
                <div className="ccl-exam-img">
                  <img
                    src="/images/web-new-images/poc-img.png"
                    alt="Register Now"
                  />
                </div>
              </div>
              <div className="col-md-6 what-ielts-content">
                <p>
                  The PTE (Pearson Test of English) is a computer-based test designed to assess English proficiency for academic, work, or immigration purposes. Our PTE Training Online program helps you master this fast, efficient, and globally recognized test.
                </p>
              </div>
            </div>
            <div className="pc-skill-areas">
              <h2 className="pc-pte-core-title">
                The exam evaluates four essential skill areas
              </h2>
              <div className="skill-areas-content">
                <div className="left-area">
                  <h2>Skill Area</h2>
                  <ul>
                    <li>Reading</li>
                    <li>Writing</li>
                    <li>Listening</li>
                    <li>Speaking</li>
                  </ul>
                </div>
                <div className="right-area">
                  <h2>What It Tests</h2>
                  <ul>
                    <li>Comprehension, vocabulary, text analysis</li>
                    <li>Essay writing, summarizing information</li>
                    <li>Understanding spoken English, main ideas</li>
                    <li>Fluency, pronunciation, and coherence</li>
                  </ul>
                </div>
              </div>
              <p>
                By pairing your motivation with structured preparation, you'll not only perform well but also gain the confidence needed to tackle the test format head-on. So why wait?
              </p>
              <div className="text-center">
                <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    START YOUR PTE JOURNEY NOW
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="choice-ielts">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading dark-blue-color text-center fw-700">
                <span className="wpl-badge gold-badge text-white">
                  WHY CHOOSE PTE?
                </span>{" "}
                <br className="d-block" />5 REASONS IT'S THE RIGHT{" "}
                <br className="d-none d-md-block" /> CHOICE FOR YOU
              </h2>
              <div className="plan-cards d-none d-md-flex">
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Quick Results</h2>
                      <p>
                        Receive your scores within 24 hours—ideal for busy
                        students and residency applicants.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Fair Scoring System</h2>
                      <p>
                        AI-powered scoring ensures unbiased and consistent
                        evaluations every time.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Flexibility</h2>
                      <p>
                        Year-round availability and global test centers provide
                        convenient scheduling options.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>User-Friendly Format</h2>
                      <p>
                        Fully digital, making it simpler to navigate <br className="d-none d-md-block" /> for tech-savvy learners
                      </p>
                    </div>
                  </div>
                </div>
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Comprehensive Recognition</h2>
                      <p>
                        Accepted by global institutions and immigration{" "}
                        <br className="d-none d-lg-block" /> authorities
                        worldwide.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                <Slider {...CardsSlider} className="plan-cards">
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>Quick Results</h2>
                        <p>
                          Receive your scores within 24 hours—ideal for busy
                          students and residency applicants.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>Fair Scoring System</h2>
                        <p>
                          AI-powered scoring ensures unbiased and consistent
                          evaluations every time.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>Flexibility</h2>
                        <p>
                          Year-round availability and global test centers
                          provide convenient scheduling options.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>User-Friendly Format</h2>
                        <p>
                          Fully digital, making it simpler to navigate for
                          tech-savvy learners.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>Comprehensive Recognition</h2>
                        <p>
                          Accepted by global institutions and immigration
                          authorities worldwide.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <p className="light-blue-box">
                  Leave behind outdated and less efficient test formats—PTE offers a modern, streamlined option that aligns with your goals. Our PTE Preparation Online program ensures you're fully prepared.
                </p>
              </div>
              <div className="col-md-6 text-center text-md-end">
                <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    REGISTER FOR YOUR PTE PREP COURSE
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="ielts-coaching pte-success poc-success">
          <div className="container">
            <div className="row">
              <div className="ielts-coaching-header text-center">
                
                <h2 className="primary-heading fw-700">
                  PREPARE FOR <span className="wpl-badge gold-badge text-white">
                    PTE
                  </span>
                  <br />
                  <span className="wpl-badge gold-badge text-white">
                    with expert GUIDANCE
                  </span>
                  <br />
                  YOUR KEY TO SUCCESS
                </h2>
              </div>
            </div>
            <div className="row pte-success-row align-items-center">
              <div className="col-lg-6">
                <img
                  src="/images/web-new-images/poc-img-01.png"
                  alt="Register Now"
                />
              </div>
              <div className="col-lg-6">
                <p className="sub-title">
                  Struggling with English proficiency or unfamiliar test formats?                 
                </p>
                <br />
                <p>
                   Struggling with English proficiency or unfamiliar test formats? You're not alone! We understand the challenges non-native English speakers face, especially when aiming for residency, work, or study opportunities abroad. Our PTE Coaching Classes solutions are tailored to
                </p>
                <br />
                <ul className="circle-list">
                  <li>Boost English proficiency</li>
                  <li>Increase test-taking confidence</li>
                  <li>Provide personalized study strategies</li>
                </ul>
              </div>
            </div>
            <h2 className="comprehensive-title fw-500 text-center text-white">
              YOUR PTE ONLINE COACHING ADVANTAGE
            </h2>
            <p className="sub-title text-center">
              Our platform combines cutting-edge learning tools, experienced tutors, <br className="d-none d-md-block" /> and proven strategies to deliver consistent results. At the heart of our PTE Online Classes practice are
            </p>
            <div className="feature-cards online-coaching-cards card-56 d-none d-md-grid">
              <div className="feature-card card1">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>
                  AI-POWERED <br /> PRACTICE TOOLS
                </h3>
                <p>
                  Simulate the test environment to understand your strengths and address weaknesses.
                </p>
              </div>
              <div className="feature-card card2">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#0286FF"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>
                  PERSONALIZED PTE ONLINE <br /> TRAINING SUPPORT 
                </h3>
                <p>
                 Receive one-on-one insights tailored for your improvement areas.
                </p>
              </div>
              <div className="feature-card card3">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>
                  CUSTOMIZED PTE <br /> ONLINE COURSE PLANS
                </h3>
                <p>
                  Develop an efficient roadmap to achieve your target scores.
                </p>
              </div>
              <div className="feature-card card4">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#FFB02C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>
                  REAL-TIME <br /> FEEDBACK
                </h3>
                <p>
                  Fine-tune your speaking and writing skills with instant feedback.
                </p>
              </div>
              <div className="feature-card card5">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#7F56D9"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>
                  PROVEN <br /> STRATEGIES
                </h3>
                <p>
                  Master exam techniques to maximize <br className="d-none d-md-block" /> your performance in each skill area.
                </p>
              </div>
            </div>
            {/* Mobile Slider HTML */}
            <div className="slider-dot-arrow d-block d-md-none mobile-slider transparent-arrows">
              <Slider
                {...CardsSlider}
                className="feature-cards online-coaching-cards card-56"
              >
                <div className="feature-card card1">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>
                  AI-POWERED <br /> PRACTICE TOOLS
                </h3>
                <p>
                  Simulate the test environment to understand your strengths and address weaknesses.
                </p>
                </div>
                <div className="feature-card card2">
                  <div className="feature-icon-outer">
                    <div className="feature-count">
                      <span>
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.57812L9 17.5781L4 12.5781"
                            stroke="#0286FF"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <h3>
                    PERSONALIZED PTE ONLINE <br /> TRAINING SUPPORT 
                  </h3>
                  <p>
                  Receive one-on-one insights tailored for your improvement areas.
                  </p>
                </div>
                <div className="feature-card card3">
                  <div className="feature-icon-outer">
                    <div className="feature-count">
                      <span>
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.57812L9 17.5781L4 12.5781"
                            stroke="#94C23C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <h3>
                    CUSTOMIZED PTE <br /> ONLINE COURSE PLANS
                  </h3>
                  <p>
                    Develop an efficient roadmap to achieve your target scores.
                  </p>
                </div>
                <div className="feature-card card4">
                  <div className="feature-icon-outer">
                    <div className="feature-count">
                      <span>
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.57812L9 17.5781L4 12.5781"
                            stroke="#FFB02C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <h3>
                    REAL-TIME <br /> FEEDBACK
                  </h3>
                  <p>
                    Fine-tune your speaking and writing skills with instant feedback.
                  </p>
                </div>
                <div className="feature-card card5">
                  <div className="feature-icon-outer">
                    <div className="feature-count">
                      <span>
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.57812L9 17.5781L4 12.5781"
                            stroke="#7F56D9"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <h3>
                    PROVEN <br /> STRATEGIES
                  </h3>
                  <p>
                    Master exam techniques to maximize <br className="d-none d-md-block" /> your performance in each skill area.
                  </p>
                </div>
              </Slider>
            </div>
            <div className="row pte-success-btn">             
              <div className="col-md-12">
                <div className="text-center">
                  <Link to="/contact" className="primary-btn">
                    ACHIEVE YOUR PTE GOALS WITH US
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="master-all-pte">
              <div className="container">
                <div className="row">
                  <div className="master-all-header">
                    <h2 className="primary-heading fw-700 text-center text-white">
                      MASTER EVERY <br className="d-block d-md-none" /> <span className="wpl-badge pte-naati-badge text-white">
                        PTE SKILL</span> <br className="d-block d-md-none" /> our <br className="d-none d-md-block" /> SECTION-SPECIFIC PTE PREPARATION <br className="d-none d-md-block" /> ONLINE STRATEGIES
                    </h2>
                  </div>
                </div>
                <div className="master-all-tabs">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="speak-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#speak-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="speak-tab-pane"
                        aria-selected="true"
                      >
                        <img
                          src="/images/web-new-images/icons/w-speak-icon.svg"
                          alt="Register Now"
                        />{" "}
                        Speaking
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="write-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#write-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="write-tab-pane"
                        aria-selected="false"
                      >
                        <img
                          src="/images/web-new-images/icons/w-write-icon.svg"
                          alt="Register Now"
                        />{" "}
                        Writing
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#profile-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="profile-tab-pane"
                        aria-selected="false"
                      >
                        <img
                          src="/images/web-new-images/icons/w-reading-icon.svg"
                          alt="Register Now"
                        />{" "}
                        Reading
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="false"
                      >
                        <img
                          src="/images/web-new-images/icons/w-listen-icon.svg"
                          alt="Register Now"
                        />{" "}
                        Listening
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade"
                      id="home-tab-pane"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                      tabIndex="0"
                    >
                      <div className="master-tab-cards">
                        <div className="test-card">
                          <h2>What It Tests</h2>
                          <ul>
                            <li>
                              Understanding accents, note-taking, following spoken instructions.
                            </li>
                          </ul>
                        </div>
                        <div className="approach-card">
                          <div className="card-img">
                            <img
                              src="/images/web-new-images/icons/w-listen-icon.svg"
                              alt="Register Now"
                            />
                          </div>
                          <h2>Our PTE Online Classes Approach</h2>
                          <ul>
                            <li>
                              Simulated listening exercises, focus on accents, and key information identification.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="profile-tab-pane"
                      role="tabpanel"
                      aria-labelledby="profile-tab"
                      tabIndex="0"
                    >
                      <div className="master-tab-cards">
                        <div className="test-card">
                          <h2>What It Tests</h2>
                          <ul>
                            <li>
                              Comprehension of both academic and non-academic texts, structure awareness.
                            </li>
                          </ul>
                        </div>
                        <div className="approach-card">
                          <div className="card-img">
                            <img
                              src="/images/web-new-images/icons/w-reading-icon.svg"
                              alt="Register Now"
                            />
                          </div>
                          <h2>Our PTE Online Training Approach</h2>
                          <ul>
                            <li>
                              Time management techniques, reordering paragraphs, and vocabulary strengthening.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="write-tab-pane"
                      role="tabpanel"
                      aria-labelledby="write-tab"
                      tabIndex="0"
                    >
                      <div className="master-tab-cards">
                        <div className="test-card">
                          <h2>What It Tests</h2>
                          <ul>
                            <li>
                              Essay organization, grammar, summarizing passages.
                            </li>
                          </ul>
                        </div>
                        <div className="approach-card">
                          <div className="card-img">
                            <img
                              src="/images/web-new-images/icons/w-write-icon.svg"
                              alt="Register Now"
                            />
                          </div>
                          <h2>Our PTE Online Training Approach</h2>
                          <ul>
                            <li>
                              Templates for essay success, grammar enhancement strategies, and summarization tips.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade show active"
                      id="speak-tab-pane"
                      role="tabpanel"
                      aria-labelledby="speak-tab"
                      tabIndex="0"
                    >
                      <div className="master-tab-cards">
                        <div className="test-card">
                          <h2>What It Tests</h2>
                          <ul>
                            <li>
                              Pronunciation, fluency, and verbal clarity.
                            </li>
                          </ul>
                        </div>
                        <div className="approach-card">
                          <div className="card-img">
                            <img
                              src="/images/web-new-images/icons/w-speak-icon.svg"
                              alt="Register Now"
                            />
                          </div>
                          <h2>Our PTE Online Coaching Approach</h2>
                          <ul>
                            <li>
                              AI-driven pronunciation improvement, confidence-building exercises, and fluency strategies.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row master-all-footer">
                  <div className="col-md-12">
                    <div className="light-blue-box text-center mb-4">
                      Gain expertise in every skill area and feel fully prepared to deliver your best performance on test day.
                    </div>
                  </div>
                  <div className="col-md-12 text-center">
                    <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        ENROLL IN YOUR PTE PROGRAM
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ielts-achievment">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 text-center">
                <h2 className="primary-heading fw-700">
                  <span className="wpl-badge text-white">
                    OUR PROMISE
                  </span>
                  <br />
                  PTE ONLINE COACHING <br className="d-none d-md-block" /> YOU CAN COUNT ON
                </h2>
              </div>  
              <div className="col-lg-6">
                <div className="achievment-card">
                  <div className="icon-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 21.6885L11.8999 21.5384C11.2053 20.4964 10.858 19.9754 10.3991 19.5983C9.99286 19.2644 9.52476 19.0139 9.02161 18.8611C8.45325 18.6885 7.82711 18.6885 6.57482 18.6885H5.2C4.07989 18.6885 3.51984 18.6885 3.09202 18.4705C2.71569 18.2787 2.40973 17.9728 2.21799 17.5965C2 17.1686 2 16.6086 2 15.4885V6.88848C2 5.76837 2 5.20832 2.21799 4.7805C2.40973 4.40417 2.71569 4.09821 3.09202 3.90646C3.51984 3.68848 4.07989 3.68848 5.2 3.68848H5.6C7.84021 3.68848 8.96031 3.68848 9.81596 4.12445C10.5686 4.50794 11.1805 5.11987 11.564 5.87251C12 6.72816 12 7.84827 12 10.0885M12 21.6885V10.0885M12 21.6885L12.1001 21.5384C12.7947 20.4964 13.142 19.9754 13.6009 19.5983C14.0071 19.2644 14.4752 19.0139 14.9784 18.8611C15.5467 18.6885 16.1729 18.6885 17.4252 18.6885H18.8C19.9201 18.6885 20.4802 18.6885 20.908 18.4705C21.2843 18.2787 21.5903 17.9728 21.782 17.5965C22 17.1686 22 16.6086 22 15.4885V6.88848C22 5.76837 22 5.20832 21.782 4.7805C21.5903 4.40417 21.2843 4.09821 20.908 3.90646C20.4802 3.68848 19.9201 3.68848 18.8 3.68848H18.4C16.1598 3.68848 15.0397 3.68848 14.184 4.12445C13.4314 4.50794 12.8195 5.11987 12.436 5.87251C12 6.72816 12 7.84827 12 10.0885"
                        stroke="#94C23C"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="achievment-content">
                    <p className="mt-2">
                      At <strong className="fw-700">Language Academy,</strong> we believe in empowering students to overcome their language struggles and achieve life-changing results. We address your primary complaints, lack of confidence, test anxiety, and unfamiliarity with the format, through expert coaching and detailed preparation plans.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         <div className="sss-section">
            <OnlineStudentSlider title={`<span className="fw-700">Hear From Our</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">PTE Training Online Students</span>`} />
            <div className="container">
              <div className="text-center bottom-btn-wrapper">
                <p className="sub-heading">
                  Your Success Is Our Goal, Achieve yours today.
                </p>
                <Link to="/auth/register" className="primary-btn">
                  REGISTER FOR YOUR COURSE
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link>
              </div>
            </div>
          </div>


          <div className="pte-campus poc-campus">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 text-center poc-campus-header">
                  <h2 className="primary-heading">
                    START YOUR
                    <br />
                    <span className="wpl-badge gold-badge text-white mb-2">
                      ONLINE COACHING
                    </span>
                    <br />
                    PLAN
                  </h2>
                  <p className="text-uppercase">
                    Choose Your Preparation Package
                  </p>
                </div>
                <div className="col-lg-6">
                  <div className="pte-campus-list card1">
                    <div className="green-package-badge">PACKAGE OPTION 1</div>
                    <h2 className="list-title">ONLINE PLATFORM</h2>
                    <ul>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          AI-POWERED PORTAL ACCESS
                        </h3>
                        <p>
                          Full access to our proprietary practice platform with algorithm-based scoring
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          COMPLETE QUESTION BANK
                        </h3>
                        <p>
                          8,000+ practice questions covering all exam modules and question types
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          SCORED MOCK TESTS
                        </h3>
                        <p>
                          Take full-length simulations with precise feedback that mirrors the real exam
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          UPDATED TEMPLATES
                        </h3>
                        <p>
                          Access the latest templates designed to trigger maximum points in the scoring system
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          SELF-PACED VIDEO LESSONS
                        </h3>
                        <p>
                          Learn the core strategies at your own pace with expert-guided tutorials
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                 <div className="col-lg-6">
                  <div className="pte-campus-list card2">
                    <div className="purple-package-badge">PACKAGE OPTION 2</div>
                    <h2 className="list-title">ONLINE COACHING</h2>
                    <h2 className="list-sub-title">Everything in the Online Platform package, PLUS</h2>
                    <ul>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          LIVE VIRTUAL CLASSES
                        </h3>
                        <p>
                          Join expert-led sessions focusing on each component of the exam
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          PERSONALIZED FEEDBACK
                        </h3>
                        <p>
                          Receive detailed analysis of your performance with specific improvement strategies
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          DIRECT TRAINER ACCESS
                        </h3>
                        <p>
                          Get your questions answered directly by our experienced instructors
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          PREDICTION FILES
                        </h3>
                        <p>
                          Access constantly updated prediction materials based on recent exam patterns
                        </p>
                      </li>
                      <li>
                        <h3>
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.301758"
                              width="40"
                              height="40"
                              rx="20"
                              fill="#48A75C"
                              fillOpacity="0.12"
                            />
                            <path
                              d="M28 14.3018L17 25.3018L12 20.3018"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          PRIORITY SUPPORT
                        </h3>
                        <p>
                          Fast-track assistance whenever you face challenges in your preparation
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="text-center pte-campus-btns">
                    <Link to="/contact" className="primary-btn ouiline-btn mb-2">
                      Contact Us
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </Link>
                    <Link to="/auth/register" className="primary-btn">
                      Register On Online Platform
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="downlaodnow-row">
                <div className="downlaodnow-content">
                  <h2>PTE APP</h2>
                  <p>
                    Download our PTE App
                    <br />
                    from App Store and Play Store
                  </p>
                </div>
                <div className="downlaodnow-img">
                  <img
                    src="/images/web-new-images/welcome-img.png"
                    alt="Register Now"
                  />
                </div>
                <div className="downlaodnow-third-col">
                  <h3 className="downlaodnow-title">Download Now!</h3>
                  <div className="downlaodnow-btns">
                    <a target="_blank" href="https://play.google.com/store/apps/details?id=com.languageacademy" className="downlaod-btn">
                      <img
                        src="/images/web-new-images/google-play-01.svg"
                        alt="Register Now"
                      />
                    </a>
                    <a target="_blank" href="https://apps.apple.com/au/app/la-pte/id6443614190" className="downlaod-btn">
                      <img
                        src="/images/web-new-images/app-store-01.svg"
                        alt="Register Now"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <div className="faq-section mt-faq">
          <div className="container">
            <div className="row">
              <h2 className="secondary-heading text-center">
                Frequently Asked Questions
              </h2>

              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      How long does it take to prepare for the PTE test with your PTE Online Coaching?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Most students need 4-6 weeks of consistent PTE Training Online to achieve their target scores. However, preparation time varies based on your current English level and target score requirements.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Do you offer a money-back guarantee? 
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      We don't offer money-back guarantees because we focus on delivering results, not refunds. Our proven methods and expert guidance ensure you succeed from the start - that's why thousands of students have achieved their target PTE scores with us.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      How quickly can I see improvements in my PTE scores?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Many students see significant improvements within 2-3 weeks of starting our program. However, individual progress depends on your starting level and dedication to practice.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Is the AI practice platform similar to the real PTE test?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes, our AI-powered PTE Online Classes practice tools are designed to closely simulate the actual PTE test environment, helping you become familiar with the format and timing.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      Can I reschedule my coaching sessions if needed?
                    </button>
                  </h2>
                  <div
                    id="collapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFive"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes, we offer flexible scheduling for all our coaching sessions. You can reschedule with reasonable notice to accommodate your availability.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSix">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSix"
                      aria-expanded="false"
                      aria-controls="collapseSix"
                    >
                      What support do I get after completing the PTE Online Coaching program?
                    </button>
                  </h2>
                  <div
                    id="collapseSix"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingSix"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Premium and VIP students receive ongoing PTE Training Online support until they achieve their target scores. We also provide guidance on test booking and PTE Preparation Online strategies for your official PTE exam.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />

        <div
          className="modal fade"
          id="staticBackdrop1"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog main-popup">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    <img
                      className="img-fluid"
                      src="/images/web-new-images/icons/close-icon2.svg"
                      alt="LA"
                    />
                  </span>
                </button>
              </div>
              <div className="modal-body p-0">
                <div className="form-content-outer m-0">
                  <div className="form-content">
                    <div className="main-popup-img form-img">
                      <img
                        className="img-fluid"
                        src="/images/web-new-images/hero_img-02.png"
                        alt="LA"
                      />
                    </div>
                    <div className="main-popup-content form-content-right">
                      <h4 className="popup-title">Take a FREE Demo Class</h4>
                      <p className="popup-sub-title">
                        Submit Your Details Below
                      </p>
                      <div className="pte-popup-form-start">
                        <form onSubmit={this.submitForm}>
                          <div className="fieldOuter">
                            <label htmlFor="name">Name*</label>
                            <div className="form-input-outer">
                              <input
                                id="name"
                                className="form-input"
                                type="text"
                                name="name"
                                placeholder="Enter name"
                                value={this.state.name}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              />
                            </div>
                            {this.validator.message(
                              "Name",
                              this.state.name,
                              "required"
                            )}
                          </div>
                          {/* <div className="fieldOuter">
                        <div className="form-input-outer">
                          <input
                            className="form-input"
                            type="text"
                            placeholder="Phone*"
                            name="phone"
                            value={this.state.phone}
                            onChange={(e) => { this.changeInput(e)} }
                          />
                        </div>
                          {this.validator.message('Phone', this.state.phone, 'required')}
                        </div> */}
                          <div className="fieldOuter">
                            <label htmlFor="PhoneNumber">Phone Number</label>
                            <PhoneInputField
                              id="PhoneNumber"
                              value={this.state.phone}
                              changeEvent={this.handlePhoneChange}
                              addClass="popup-class"
                            />
                            {this.validator.message(
                              "phone",
                              this.state.phone,
                              "required|phone"
                            )}
                            <span className="err phone-error"></span>
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="email">Email*</label>
                            <div className="form-input-outer">
                              <input
                                id="email"
                                className="form-input"
                                type="text"
                                name="email"
                                placeholder="Enter Email"
                                value={this.state.email}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              />
                            </div>
                            {this.validator.message(
                              "Email",
                              this.state.email,
                              "required|email"
                            )}
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="center">Center</label>
                            <div className="form-input-outer form-select-wrapper">
                              <select
                                id="center"
                                className="form-input"
                                name="course"
                                value={this.state.course}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              >
                                <option value="PTE Online">PTE Online</option>
                                <option value="PTE On-Campus3">
                                  PTE On-Campus
                                </option>
                                <option value="NAATI CCL Online">
                                  NAATI CCL Online
                                </option>
                                <option value="NAATI CCL On-Campus">
                                  NAATI CCL On-Campus
                                </option>
                                <option value="IELTS Online">
                                  IELTS Online
                                </option>
                                <option value="IELTS On-Campus">
                                  IELTS On-Campus
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="comments">Comments / Query</label>
                            <div className="form-input-outer">
                              <input
                                id="comments"
                                className="form-input"
                                type="text"
                                placeholder="Enter your comments/Query"
                                name="query"
                                value={this.state.query}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              />
                            </div>
                            {this.validator.message(
                              "Query",
                              this.state.query,
                              "required"
                            )}
                          </div>
                          <div className="fieldOuter mb-0">
                            {!this.state.loginLock && (
                              <button
                                className="primary-btn"
                                onClick={(e) => {
                                  this.hitApi();
                                }}
                              >
                                SUBMIT{" "}
                                <img
                                  src="/images/web-new-images/right-arrow.svg"
                                  alt="LA"
                                />
                              </button>
                            )}
                            {this.state.loginLock && (
                              <button className="themeBtn">Wait...</button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Pte;
